import { VueClass } from "vue-class-component/lib/declarations";
import { InvoiceListItem, InvoiceListItemContent } from "@/components/List/IBInvoiceList/interface";
import { OpenAccountClientType } from "@/feature/OpenAccount/store/interface";

export enum OpenAccountField {
	phoneNumber = 'phoneNumber',
	nonClientName = 'nonClientName',
	inn = 'inn',
	isIndividualEntrepreneur = 'isIndividualEntrepreneur',
	companyName = 'companyName',
	registerDate = 'registerDate',
	registerEndDate = 'registerEndDate',
	companyAddress = 'companyAddress',
}

export enum OpenAccountFormStep {
	PHONE_NUMBER = 'PHONE_NUMBER',
	INN = 'INN',
	OTP = 'OTP',
	COMPANY_INFO = 'COMPANY_INFO',
	ACCEPTED_BY_BANK = 'ACCEPTED_BY_BANK',
	CREATED = 'CREATED',
	REJECTED_BY_BANK = 'REJECTED_BY_BANK',
	REJECTED_BY_CLIENT = 'REJECTED_BY_CLIENT',
	DONE = 'DONE',
	DISABLED_CLIENT = 'DISABLED_CLIENT',
}

export interface OpenAccountStatusContent {
	title?: string
	subtitle?: string
	caption?: string
	icon?: string
	divider?: boolean
	invoiceList?: InvoiceListItem[]
	invoiceListPartial?: InvoiceListItem[]
	list?: InvoiceListItemContent[]
}

export interface OpenAccountListItemContent extends OpenAccountStatusContent {
	text?: string
	textIsLink?: boolean
}

export type OpenAccountFormsByStep = {
	[P in OpenAccountFormStep]: VueClass<any>
}

export type OpenAccountINNVerifiedHandler = {
	[P in OpenAccountClientType]: () => void
}